export function setLoading() {
    //console.log('setLoading');
    //NProgress.start(); // start progress bar
  }
  
  export function unsetLoading() {
    //console.log('unsetLoading');
    //NProgress.done(); // start progress bar
  }
  